import axios from "axios";

import { BASE_URL } from "./api";


export async function getCompanyAssimilationLogs(token, companyId){
    return axios({
        method: 'get',
        url: `${BASE_URL}/assimilation_logs?surviving_company=${companyId}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response;
    }).catch((error) => {
        return error
    });
}

export async function getAllAssimilationLogs(token, queryParams){
    return axios({
        method: 'get',
        url: `${BASE_URL}/assimilation_logs/paginated_logs${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response;
    }).catch((error) => {
        return error
    });
}